import { useEffect, useState } from "react";
import "@/App.css";

/* ============================================================
   STORE LINKS — edit these in one place
   ============================================================ */
const STORE_LINKS = {
  etsy: "https://www.etsy.com/shop/ReelKrome",
  amazonCa: "https://www.amazon.ca/s?me=AS9YKY5PGNQ7O&marketplaceID=A2EUQ1WTGCTBG2",
  amazonCom: "https://www.amazon.com/s?me=AS9YKY5PGNQ7O&marketplaceID=ATVPDKIKX0DER",
  youtube: "https://www.youtube.com/@FireKrome",
  youtubeEmbed: "https://www.youtube.com/embed/bpNpESR7Upc",
  youtubeVideo: "https://www.youtube.com/watch?v=bpNpESR7Upc",
  instagram: "https://www.instagram.com/firekrome/",
  email: "mailto:eneoenterprises@gmail.com?subject=Hey%20I%20have%20a%20question%20for%20you...",
};

const NAV = [
  { label: "Why Reel Krome", href: "#why" },
  { label: "Reviews", href: "#reviews" },
  { label: "Products", href: "#products" },
  { label: "Gallery", href: "#gallery" },
  { label: "Founder", href: "#founder" },
  { label: "FAQ", href: "#faq" },
];

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/csoguh5k_81Jc8OMgzZL._AC_SL1500_.jpg";

const WHY_POINTS = [
  "Brush application",
  "Airbrush application",
  "Brilliant chrome appearance",
  "Designed for display pieces",
  "Developed from professional film & television prop experience",
];

const REEL_KROME_PRICE = "$27 CAD";

const FEATURED_QUOTE = {
  quote: "I've never found anything with quite the shine as Reel Krome.",
  name: "Verified Etsy Buyer",
};

const STUDIOS = ["DISNEY", "PARAMOUNT", "NETFLIX", "FOX", "HBO", "AMAZON STUDIOS", "APPLE TV+"];
const CREDITS = ["SHOGUN", "TRACKER", "GOD OF WAR", "PERCY JACKSON", "+DOZENS MORE"];

const PRODUCTS = [
  {
    sku: "FK-60",
    name: "FireKrome",
    tagline: "Reflective Finish",
    image: "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/rrw642qu_51XY2h2hxyL._AC_SL1069_.jpg",
    amazonCa: "https://www.amazon.ca/Activated-Liquid-Reflective-Professional-Television/dp/B0GPLT8NRW/ref=cm_cr_arp_d_pb_opt?ie=UTF8",
    amazonCom: "https://www.amazon.com/Fire-Krome-30ml-60-milliliters/dp/B0GPLT8NRW/ref=sr_1_1?dib=eyJ2IjoiMSJ9.EYgBtcF78ZRFCnRXmRGdbzv-iYGt9T-nYusJ9E2yTTXGjHj071QN20LucGBJIEps.2sSXmGpz5Pyx1-4TyD7vVbbSYyoQge1uFAGV3v0b1hQ&dib_tag=se&m=AS9YKY5PGNQ7O&marketplaceID=ATVPDKIKX0DER&nsdOptOutParam=true&qid=1788442184&s=merchant-items&sr=1-1&th=1",
    blurb:
      "Flame-activated mirror finish in minutes. Built for HERO props that need true reflective accents or complete finish. MUST be sealed or top coated.",
    price: "$24 CAD",
    features: ["Flame Activated", "Reflective chrome", "Easy Application"],
  },
  {
    sku: "RK-30",
    name: "Reel Krome",
    tagline: "Brush On & Done",
    image: "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/060igvei_716WOF6cduL._AC_SL1500_.jpg",
    amazonAvailable: true,
    amazonCa: "https://www.amazon.ca/KROME-Premium-Liquid-Chrome-Brush/dp/B0GSLLQLJL/ref=sr_1_1?dib=eyJ2IjoiMSJ9.svd29c7MPi-FuFOPcp6jGTv-iYGt9T-nYusJ9E2yTTXGjHj071QN20LucGBJIEps.fbgZSzlocRkQ3LJ6w3u8NkLkxY2BWzn_saMfn-wa48I&dib_tag=se&m=AS9YKY5PGNQ7O&marketplaceID=A2EUQ1WTGCTBG2&qid=1788442470&s=merchant-items&sr=1-1",
    amazonCom: "https://www.amazon.com/dp/B0GSLLQLJL",
    blurb:
      "The absolute easiest product we have. Brush on or airbrush, and DONE! Reel Krome is best suited for display pieces, doesn't like handling and cannot be top coated.",
    price: REEL_KROME_PRICE,
    features: ["Easy Brush On", "Cast Aluminum look", "Best for Display Pieces"],
  },
  {
    sku: "SL-60",
    name: "Silver Lightning",
    tagline: "Airbrush Faux Chrome",
    image: "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/miciy7wb_71RVi26gPFL._AC_SL1500_.jpg",
    amazonCa: "https://www.amazon.ca/Silver-Lightning-Chrome-Milliliters-Cosplay/dp/B0H13Q5KHD/ref=sr_1_2?dib=eyJ2IjoiMSJ9.svd29c7MPi-FuFOPcp6jGTv-iYGt9T-nYusJ9E2yTTXGjHj071QN20LucGBJIEps.fbgZSzlocRkQ3LJ6w3u8NkLkxY2BWzn_saMfn-wa48I&dib_tag=se&m=AS9YKY5PGNQ7O&marketplaceID=A2EUQ1WTGCTBG2&qid=1788442347&s=merchant-items&sr=1-2",
    amazonCom: "https://www.amazon.com/dp/B0H13Q5KHD",
    blurb:
      "Silver Lightning is your go-to standard for all things steel. Featured on TRACKER, SHŌGUN and PERCY JACKSON.",
    price: "$27 CAD",
    features: ["Industry Standard", "Use Gloss Black Base", "Very Versatile"],
  },
];

const GALLERY = [
  { url: "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/22z6608j_81RcylV4M4L._AC_SL1500_.jpg", label: "Reel Krome // Stunt Pistol", span: "row-span-2" },
  { url: "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/7fxem18w_81lCr95ztPL._AC_SL1500_.jpg", label: "FireKrome // Hero Skull" },
  { url: "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/adm8ppdj_91Z7Wg54Q3L._AC_SL1500_.jpg", label: "FireKrome // Tacoma PD Badges", span: "col-span-2" },
  { url: "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/csoguh5k_81Jc8OMgzZL._AC_SL1500_.jpg", label: "Reel Krome // Chrome Skull" },
  { url: "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/jmdj7lcy_81Ub-uVG7wL._AC_SL1500_.jpg", label: "Reel Krome // Foam Soda Cans" },
  { url: "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/uqel2i3u_91OaVZtGVVL._AC_SL1500_.jpg", label: "Silver Lightning // Sample Spoons" },
  { url: "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/lwp64b7o_Subject%204.jpg", label: "Silver Lightning // Stunt Pistol Side", span: "col-span-2" },
  { url: "https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/6b46djw5_Subject%203.jpg", label: "Silver Lightning // Rear Sight Detail", span: "col-span-2" },
];

const REVIEWS = [
  {
    id: "wnF8tbids48",
    start: 370,
    title: "Reel Krome // Brushed & Airbrushed",
    source: "Barbatos Rex • YouTube",
    blurb:
      "An independent reviewer puts Reel Krome through its paces — brushed and airbrushed application, finish quality, and the cast-aluminum look, all on camera.",
  },
];

const TESTIMONIALS = [
  {
    quote:
      "Chrome paints are bountiful these days but vary in quality big time. This is easily one of the best that I have personally tried. The fact that it can be hand painted and still look great as well is a major plus that you really don't get with other chrome paints. Highly recommend!",
    name: "David",
    product: "Reel Krome",
    date: "Jul 2026",
  },
  {
    quote:
      "This product is fantastic! It offers multiple easy application options, including paint, dip, and airbrush. One of the best Chrome effects I've tried — I've used it on gloss plastic, resin prints, and filament prints. Self-levelling is a huge plus. I'll definitely be buying it again.",
    name: "Tim",
    product: "Reel Krome",
    date: "Jun 2026",
  },
  {
    quote:
      "A huge THANK YOU! After many years of searching, I have finally found a great compromise between real chrome plating and chrome paint.",
    name: "SandPaper",
    product: "FireKrome",
    date: "Feb 2026",
  },
  {
    quote: "Amazing paint, amazing seller! Can't recommend both enough.",
    name: "atlanteum",
    product: "Reel Krome",
    date: "Jul 2026",
  },
  {
    quote: "One of the best chromes on the market.",
    name: "Jay",
    product: "Reel Krome",
    date: "Jul 2026",
  },
  {
    quote: "Very pleased. Next best thing to chrome itself.",
    name: "bubba",
    product: "Reel Krome",
    date: "Jul 2026",
  },
];


const FAQ = [
  { q: "How long does FireKrome take to dry?", a: "Firekrome is ready almost instantly. You brush it on, dry by air or a hair dryer, repeat, activate with flame and VOILA! Apply a quick clear to seal and DONE!" },
  { q: "What can it cover?", a: "Practically anything, as long as the base is as glossy as possible to achieve maximum reflectivity." },
  { q: "Do I need spray equipment?", a: "No! Firekrome works just fine applied with a brush. It flows out, evaporates and leaves a near invisible micro layer behind." },
  { q: "Can I top-coat it?", a: "You MUST top coat Firekrome! If you do not, it will rub off. In fact, if you make a mistake and wish to start again, you can literally WASH OFF Firekrome and start again!" },
  { q: "Do you ship internationally?", a: "We ship across North America via Amazon or Etsy (US & Canada). For global orders, please use our Etsy store. Will ship to Mars once Elon has established himself there." },
  { q: "Is it safe to use?", a: "Firekrome is water soluble, however always use gloves as it can stain your fingers." },
];

const SCROLL_THRESHOLD_PX = 24;

export default function App() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [demoOpen, setDemoOpen] = useState(false);
  const [pastHero, setPastHero] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > SCROLL_THRESHOLD_PX);
      const hero = document.getElementById("top");
      setPastHero(!!hero && window.scrollY > hero.offsetHeight - 80);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="App grain" data-testid="firekrome-app">
      <Nav scrolled={scrolled} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <Hero onPlayDemo={() => setDemoOpen(true)} />
      <WhyReelKrome />
      <Reviews />
      <StudioMarquee />
      <Products />
      <DemoVideo />
      <Gallery />
      <Founder />
      <Faq />
      <CtaStrip />
      <Footer />
      <StickyBuyBar visible={pastHero} />
      {demoOpen && <DemoModal onClose={() => setDemoOpen(false)} />}
    </div>
  );
}

/* ================== STICKY BUY BAR (mobile) ================== */
function StickyBuyBar({ visible }) {
  return (
    <div
      data-testid="sticky-buy-bar"
      aria-hidden={!visible}
      className={`md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-zinc-800 bg-[#121212]/95 backdrop-blur-md px-4 py-3 flex items-center justify-between gap-3 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full pointer-events-none"
      }`}
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
      <div className="min-w-0">
        <p className="font-heading uppercase font-bold tracking-tight text-lg leading-none chrome-text">Reel Krome</p>
        <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-400 mt-1">
          <span className="text-[#FF5A00]">★★★★★</span> · {REEL_KROME_PRICE}
        </p>
      </div>
      <a
        href={STORE_LINKS.etsy}
        target="_blank"
        rel="noopener noreferrer"
        tabIndex={visible ? 0 : -1}
        data-testid="sticky-buy-bar-btn"
        className="btn-primary shrink-0"
        style={{ padding: "0.8rem 1.1rem", fontSize: "0.7rem" }}
      >
        Buy Reel Krome →
      </a>
    </div>
  );
}

/* ================== DEMO MODAL ================== */
function DemoModal({ onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  return (
    <div
      data-testid="demo-modal"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Reel Krome demo video"
      className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-md flex items-center justify-center p-4 md:p-10"
      style={{ animation: "fadeIn 0.18s ease-out" }}
    >
      <button
        type="button"
        onClick={onClose}
        data-testid="demo-modal-close"
        aria-label="Close video"
        className="absolute top-4 right-4 md:top-6 md:right-6 w-12 h-12 rounded-full border border-zinc-700 bg-black/60 text-zinc-200 hover:bg-[#FF5A00] hover:border-[#FF5A00] hover:text-white transition-colors flex items-center justify-center font-mono text-xl z-10"
      >
        ✕
      </button>
      <div onClick={(e) => e.stopPropagation()} className="relative w-full max-w-5xl aspect-video bracket-card overflow-hidden">
        <iframe
          data-testid="demo-modal-iframe"
          src={`${STORE_LINKS.youtubeEmbed}?autoplay=1&rel=0`}
          title="Reel Krome demo video"
          className="absolute inset-0 w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          frameBorder="0"
        />
      </div>
    </div>
  );
}

/* ================== WHY REEL KROME ================== */
function WhyReelKrome() {
  return (
    <section id="why" data-testid="why-section" className="py-20 md:py-28 border-b border-zinc-800 bg-[#0e0e0e]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 md:gap-12">
        <div className="md:col-span-5">
          <p className="tech-label mb-4"><span className="text-[#FF5A00]">●</span> Section 01 // Why</p>
          <h2 data-testid="why-heading" className="font-heading text-5xl md:text-7xl uppercase font-bold tracking-tighter leading-[0.9]">
            Why <span className="chrome-text">Reel Krome?</span>
          </h2>
        </div>
        <ul className="md:col-span-7 border-t border-zinc-800">
          {WHY_POINTS.map((point, i) => (
            <li
              key={point}
              data-testid={`why-point-${i}`}
              className="flex items-start gap-5 py-5 border-b border-zinc-800 rise"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <span className="shrink-0 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-[#FF5A00] text-black font-bold text-lg">✓</span>
              <span className="font-heading text-xl md:text-3xl uppercase tracking-tight text-zinc-100 leading-tight pt-0.5">{point}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

/* ================== NAV ================== */
function Nav({ scrolled, mobileOpen, setMobileOpen }) {
  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#121212]/95 backdrop-blur-md border-b border-zinc-800" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between h-16">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src="https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/ani5jwna_eNeo%20gold%20button.png"
            alt="eNeo / FireKrome"
            className="h-10 w-10 md:h-11 md:w-11 object-contain drop-shadow-[0_2px_8px_rgba(255,200,80,0.35)]"
          />
          <span className="font-heading text-base md:text-xl tracking-[0.25em] uppercase font-bold text-zinc-200">
            Fire<span className="chrome-text">Krome</span>
          </span>
        </a>
        <ul className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <li key={n.href}>
              <a
                href={n.href}
                data-testid={`nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400 hover:text-[#FF5A00] transition-colors"
              >
                {n.label}
              </a>
            </li>
          ))}
        </ul>
        <a
          href={STORE_LINKS.etsy}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-shop-btn"
          className="hidden md:inline-flex btn-primary"
          style={{ padding: "0.65rem 1.4rem", fontSize: "0.7rem" }}
        >
          Shop <span className="spark-dot rivet" style={{ background: "#fff" }} />
        </a>
        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          className="md:hidden text-zinc-200"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <div className="space-y-1.5">
            <span className="block w-7 h-px bg-current" />
            <span className="block w-7 h-px bg-current" />
            <span className="block w-7 h-px bg-current" />
          </div>
        </button>
      </div>
      {mobileOpen && (
        <div className="md:hidden border-t border-zinc-800 bg-[#121212]" data-testid="mobile-menu">
          <ul className="flex flex-col px-6 py-4 gap-4">
            {NAV.map((n) => (
              <li key={n.href}>
                <a
                  href={n.href}
                  onClick={() => setMobileOpen(false)}
                  data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="font-mono text-xs uppercase tracking-widest text-zinc-300 hover:text-[#FF5A00]"
                >
                  {n.label}
                </a>
              </li>
            ))}
            <li>
              <a href={STORE_LINKS.etsy} target="_blank" rel="noopener noreferrer" className="btn-primary inline-flex">
                Shop Now
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}

/* ================== HERO ================== */
function Hero({ onPlayDemo }) {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Skull finished in Reel Krome liquid chrome"
          data-testid="hero-bg-image"
          className="w-full h-full object-cover object-[60%_center] md:object-right opacity-75"
        />
        <div className="absolute inset-0 hero-scrim" />
        <div className="absolute inset-0 blueprint-grid opacity-40" />
      </div>

      {/* Top tech bar */}
      <div className="absolute top-20 md:top-24 left-0 right-0 px-6 md:px-12 flex items-center justify-between text-zinc-500 z-10">
        <span className="tech-label">LOT // 2026-01 / VANCOUVER BC</span>
        <span className="tech-label hidden md:inline">EST. ON SET • TERRY WEAVER • IATSE 891</span>
        <span className="tech-label hidden sm:inline">N 49°16′ // W 123°06′</span>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 pt-36 pb-28 md:pb-36 w-full">
        <div className="max-w-5xl">
          <p className="tech-label mb-6 rise" data-testid="hero-eyebrow">
            <span className="text-[#FF5A00]">●</span> Professional Liquid Chrome // By eNeo
          </p>
          <h1
            data-testid="hero-headline"
            className="rise rise-d1 font-heading uppercase font-bold tracking-tighter leading-[0.85]"
          >
            <span className="block chrome-text text-[17vw] sm:text-[14vw] md:text-[10vw]">Reel Krome</span>
            <span className="block text-[#FF5A00] text-[8.5vw] sm:text-[6.5vw] md:text-[4.6vw] mt-2 md:mt-3">
              The chrome you can brush on.
            </span>
          </h1>
          <p
            data-testid="hero-subhead"
            className="rise rise-d2 mt-8 max-w-2xl text-lg md:text-xl text-zinc-200 leading-relaxed font-body"
          >
            Professional liquid chrome for models, props, 3D prints, miniatures and cosplay.
          </p>
          <p data-testid="hero-tagline" className="rise rise-d2 mt-3 font-mono text-sm md:text-base uppercase tracking-[0.2em] text-zinc-400">
            Brush it. Spray it. <span className="text-white">Watch it turn chrome.</span>
          </p>
          <div className="rise rise-d3 mt-10 flex flex-wrap gap-4 items-center">
            <button type="button" onClick={onPlayDemo} data-testid="hero-demo-btn" className="btn-primary">
              ▶ Watch the 30-second demo
            </button>
            <a href="#product-RK-30" data-testid="hero-buy-reel-krome-btn" className="btn-secondary">
              Buy Reel Krome →
            </a>
          </div>
        </div>
      </div>

      {/* Bottom credits ticker */}
      <div className="absolute bottom-0 left-0 right-0 border-t border-zinc-800 bg-[#0a0a0a]/80 backdrop-blur-sm z-10">
        <div className="flex items-center overflow-hidden whitespace-nowrap py-3">
          <div className="marquee-track">
            {[...STUDIOS, ...STUDIOS].map((s, i) => (
              <span key={`${s}-${i}`} className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500 px-8 inline-flex items-center gap-8">
                {s} <span className="text-zinc-700">/</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ================== STUDIO STRIP ================== */
function StudioMarquee() {
  return (
    <section data-testid="credits-section" className="border-y border-zinc-800 bg-[#0e0e0e] py-12">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <p className="tech-label mb-8 text-center">As Seen On // Featured Productions</p>
        <div className="flex flex-wrap justify-center items-baseline gap-x-8 md:gap-x-16 gap-y-4">
          {CREDITS.map((c) => (
            <span
              key={c}
              className="font-heading text-2xl md:text-4xl uppercase font-bold tracking-tight"
              style={{
                background: "linear-gradient(180deg, #e4e4e7 0%, #71717a 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {c}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ================== PRODUCTS ================== */
function Products() {
  return (
    <section id="products" data-testid="products-section" className="py-24 md:py-32 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-16">
          <div className="md:col-span-7">
            <p className="tech-label mb-4"><span className="text-[#FF5A00]">●</span> Section 03 // Shop</p>
            <h2 className="font-heading text-5xl md:text-7xl uppercase font-bold tracking-tighter leading-[0.9]">
              Three Finishes.<br />
              <span className="chrome-text">One Shop.</span>
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-zinc-400 text-lg leading-relaxed font-body">
              Available on Amazon, Etsy and direct. Can ship overnight from Vancouver B.C. Satisfaction Guaranteed!
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {PRODUCTS.map((p, idx) => (
            <article
              key={p.sku}
              id={`product-${p.sku}`}
              data-testid={`product-card-${p.sku}`}
              className="bracket-card flex flex-col overflow-hidden scroll-mt-24"
            >
              <div className="relative h-56 bg-gradient-to-br from-zinc-900 via-zinc-950 to-black overflow-hidden border-b border-zinc-800">
                <img
                  src={p.image}
                  alt={p.name}
                  className="absolute inset-0 w-full h-full object-contain p-6"
                />
                <span className="absolute top-3 left-3 tech-label bg-black/60 px-2 py-1 text-zinc-300">{p.sku}</span>
                <span className="absolute top-3 right-3 rivet" />
              </div>
              <div className="p-8 flex flex-col flex-1">
              <h3 className="font-heading text-3xl uppercase font-bold tracking-tight mb-1">{p.name}</h3>
              <p className="tech-label text-[#FF5A00] mb-5">{p.tagline}</p>
              <p className="text-zinc-400 leading-relaxed mb-6 font-body">{p.blurb}</p>
              <ul className="space-y-2 mb-8">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-zinc-300 font-mono">
                    <span className="text-[#FF5A00] mt-1">▸</span> {f}
                  </li>
                ))}
              </ul>
              <div className="mt-auto pt-6 border-t border-zinc-800">
                <div className="space-y-2">
                  <a
                    href={STORE_LINKS.etsy}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`product-buy-etsy-${p.sku}`}
                    className="btn-primary w-full justify-center"
                  >
                    Buy on Etsy →
                  </a>
                  {p.amazonAvailable && (
                    <div className="grid grid-cols-2 gap-2">
                      <a
                        href={p.amazonCa || STORE_LINKS.amazonCa}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`product-buy-amazon-ca-${p.sku}`}
                        className="btn-secondary justify-center text-[0.65rem]"
                        style={{ padding: "0.75rem 0.5rem" }}
                      >
                        Amazon.ca
                      </a>
                      <a
                        href={p.amazonCom || STORE_LINKS.amazonCom}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`product-buy-amazon-com-${p.sku}`}
                        className="btn-secondary justify-center text-[0.65rem]"
                        style={{ padding: "0.75rem 0.5rem" }}
                      >
                        Amazon.com
                      </a>
                    </div>
                  )}
                </div>
              </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ================== DEMO VIDEO ================== */
function DemoVideo() {
  return (
    <section id="demo" data-testid="video-section" className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-4">
            <p className="tech-label mb-4"><span className="text-[#FF5A00]">●</span> Section 04 // Demo Reel</p>
            <h2 className="font-heading text-4xl md:text-5xl uppercase font-bold tracking-tighter leading-[0.95] mb-6">
              Check out our YouTube.
            </h2>
            <p className="text-zinc-400 font-body leading-relaxed mb-6">
              Tutorials, and vids to help make your project a complete success.
            </p>
            <a
              href={STORE_LINKS.youtube}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="youtube-channel-btn"
              className="btn-primary"
            >
              ▶ Visit YouTube Channel
            </a>
          </div>
          <div className="md:col-span-8">
            <div
              data-testid="video-embed-wrapper"
              className="relative aspect-video bracket-card overflow-hidden"
            >
              <iframe
                data-testid="video-iframe"
                src={STORE_LINKS.youtubeEmbed}
                title="FireKrome demo video"
                className="absolute inset-0 w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                frameBorder="0"
              />
            </div>
            <div className="mt-3 flex items-center justify-between">
              <span className="tech-label text-zinc-500">@FIREKROME // OFFICIAL DEMO</span>
              <a
                href={STORE_LINKS.youtubeVideo}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="video-open-youtube"
                className="tech-label text-zinc-400 hover:text-[#FF5A00] transition-colors"
              >
                Watch on YouTube →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ================== GALLERY ================== */
function Gallery() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const open = (i) => setLightboxIndex(i);
  const close = () => setLightboxIndex(null);
  const prev = () => setLightboxIndex((i) => (i === 0 ? GALLERY.length - 1 : i - 1));
  const next = () => setLightboxIndex((i) => (i === GALLERY.length - 1 ? 0 : i + 1));

  useEffect(() => {
    if (lightboxIndex === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") close();
      else if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [lightboxIndex]);

  const current = lightboxIndex !== null ? GALLERY[lightboxIndex] : null;

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 border-y border-zinc-800 bg-[#0e0e0e]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-12">
          <div className="md:col-span-8">
            <p className="tech-label mb-4"><span className="text-[#FF5A00]">●</span> Section 05 // Field Work</p>
            <h2 className="font-heading text-5xl md:text-7xl uppercase font-bold tracking-tighter leading-[0.9]">
              Prop Builds.<br />
              <span className="chrome-text">Camera Ready.</span>
            </h2>
          </div>
          <div className="md:col-span-4">
            <p className="text-zinc-400 font-body">
              A small selection of finished props using eNeo&apos;s FireKrome, Reel Krome and Silver Lightning.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[260px] md:auto-rows-[300px] gap-3 md:gap-4">
          {GALLERY.map((g, i) => (
            <button
              type="button"
              key={g.url}
              data-testid={`gallery-item-${i}`}
              onClick={() => open(i)}
              className={`relative overflow-hidden bracket-card group cursor-zoom-in text-left focus:outline-none focus:ring-2 focus:ring-[#FF5A00] ${g.span || ""}`}
              aria-label={`Enlarge ${g.label}`}
            >
              <img src={g.url} alt={g.label} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover duotone" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/60 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-white text-sm font-mono">⤢</span>
              </div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                <span className="tech-label bg-black/70 px-2 py-1 text-zinc-200">{g.label}</span>
                <span className="rivet" />
              </div>
            </button>
          ))}
        </div>
      </div>

      {current && (
        <div
          data-testid="gallery-lightbox"
          onClick={close}
          className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-sm flex items-center justify-center p-4 md:p-10 animate-[fadeIn_.18s_ease-out]"
          style={{ animation: "fadeIn 0.18s ease-out" }}
        >
          <button
            type="button"
            onClick={close}
            data-testid="lightbox-close"
            aria-label="Close"
            className="absolute top-4 right-4 md:top-6 md:right-6 w-12 h-12 rounded-full border border-zinc-700 bg-black/60 text-zinc-200 hover:bg-[#FF5A00] hover:border-[#FF5A00] hover:text-white transition-colors flex items-center justify-center font-mono text-xl z-10"
          >
            ✕
          </button>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); prev(); }}
            data-testid="lightbox-prev"
            aria-label="Previous image"
            className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 rounded-full border border-zinc-700 bg-black/60 text-zinc-200 hover:bg-[#FF5A00] hover:border-[#FF5A00] hover:text-white transition-colors flex items-center justify-center font-mono text-2xl z-10"
          >
            ‹
          </button>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); next(); }}
            data-testid="lightbox-next"
            aria-label="Next image"
            className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 rounded-full border border-zinc-700 bg-black/60 text-zinc-200 hover:bg-[#FF5A00] hover:border-[#FF5A00] hover:text-white transition-colors flex items-center justify-center font-mono text-2xl z-10"
          >
            ›
          </button>
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative max-w-[90vw] max-h-[85vh] flex flex-col items-center"
          >
            <img
              src={current.url}
              alt={current.label}
              data-testid="lightbox-image"
              className="max-w-full max-h-[80vh] object-contain shadow-2xl"
            />
            <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
              <span className="tech-label text-zinc-400">{String(lightboxIndex + 1).padStart(2, "0")} / {String(GALLERY.length).padStart(2, "0")}</span>
              <span className="text-zinc-600">·</span>
              <span className="font-heading uppercase tracking-wider text-zinc-100 text-lg">{current.label}</span>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

/* ================== REVIEWS ================== */
function Stars({ size = "text-lg" }) {
  return (
    <div className="flex items-center gap-1" aria-label="5 out of 5 stars">
      {[...Array(5)].map((_, i) => (
        <span key={i} className={`text-[#FF5A00] ${size} leading-none`}>★</span>
      ))}
    </div>
  );
}

function FeaturedQuote() {
  return (
    <figure data-testid="featured-quote" className="bracket-card p-8 md:p-14 mb-8 md:mb-10 relative overflow-hidden">
      <span aria-hidden="true" className="absolute -top-6 right-6 md:right-12 font-heading text-[10rem] md:text-[16rem] leading-none text-[#FF5A00]/15 select-none">&rdquo;</span>
      <Stars size="text-2xl md:text-3xl" />
      <blockquote className="mt-6 font-heading uppercase font-bold tracking-tight text-3xl sm:text-4xl md:text-6xl leading-[1.02] max-w-5xl relative">
        &ldquo;I&apos;ve never found anything with quite the <span className="chrome-text">shine</span> as{" "}
        <span className="text-[#FF5A00]">Reel Krome.</span>&rdquo;
      </blockquote>
      <figcaption data-testid="featured-quote-author" className="mt-8 tech-label text-zinc-300">
        — {FEATURED_QUOTE.name}
      </figcaption>
    </figure>
  );
}

function TestimonialGrid() {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
      {TESTIMONIALS.map((t, idx) => (
        <article key={`${t.name}-${idx}`} data-testid={`testimonial-${idx}`} className="bracket-card p-6 md:p-7 flex flex-col">
          <div className="mb-4"><Stars /></div>
          <p className="font-body text-zinc-200 leading-relaxed flex-1 mb-5">&ldquo;{t.quote}&rdquo;</p>
          <div className="pt-4 border-t border-zinc-800 flex items-center justify-between text-xs">
            <span className="font-heading uppercase tracking-widest text-zinc-100">{t.name}</span>
            <span className="font-mono uppercase tracking-widest text-zinc-500">{t.product} · {t.date}</span>
          </div>
        </article>
      ))}
    </div>
  );
}

function VideoReviews() {
  return (
    <div className="mt-20 md:mt-28 grid gap-10">
      {REVIEWS.map((r, idx) => (
        <article key={r.id} data-testid={`review-${idx}`} className="grid md:grid-cols-12 gap-8 items-start">
          <div className="md:col-span-8">
            <div className="relative aspect-video bracket-card overflow-hidden">
              <iframe
                src={`https://www.youtube.com/embed/${r.id}${r.start ? `?start=${r.start}` : ""}`}
                title={r.title}
                className="absolute inset-0 w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                frameBorder="0"
                loading="lazy"
                data-testid={`review-iframe-${idx}`}
              />
            </div>
          </div>
          <div className="md:col-span-4">
            <span className="tech-label text-[#FF5A00]">Video Review // {r.source}</span>
            <h3 className="font-heading text-2xl md:text-3xl uppercase font-bold tracking-tight mt-3 mb-4 leading-tight">{r.title}</h3>
            <p className="text-zinc-400 font-body leading-relaxed mb-5">{r.blurb}</p>
            <a
              href={`https://www.youtube.com/watch?v=${r.id}${r.start ? `&t=${r.start}s` : ""}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`review-link-${idx}`}
              className="tech-label text-zinc-300 hover:text-[#FF5A00] transition-colors inline-flex items-center gap-2"
            >
              Watch on YouTube →
            </a>
          </div>
        </article>
      ))}
    </div>
  );
}

function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-10 md:mb-12">
          <div>
            <p className="tech-label mb-4"><span className="text-[#FF5A00]">●</span> Section 02 // Verified 5-Star Reviews</p>
            <h2 data-testid="reviews-heading" className="font-heading text-5xl md:text-7xl uppercase font-bold tracking-tighter leading-[0.9]">
              Don&apos;t take<br />
              <span className="chrome-text">our word for it.</span>
            </h2>
          </div>
          <a
            href="https://www.etsy.com/shop/ReelKrome/reviews"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="etsy-reviews-link"
            className="btn-secondary"
          >
            Read all reviews on Etsy →
          </a>
        </div>
        <FeaturedQuote />
        <TestimonialGrid />
        <VideoReviews />
      </div>
    </section>
  );
}

/* ================== FOUNDER ================== */
function Founder() {
  return (
    <section id="founder" data-testid="founder-section" className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-5">
            <div className="relative aspect-[4/5] bracket-card overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/mwacm54x_IMG_7331%202.JPG"
                alt="Terry Weaver, founder of FireKrome"
                className="absolute inset-0 w-full h-full object-cover duotone"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <p className="tech-label text-zinc-300">Founder // Prop Master</p>
                <p className="font-heading text-3xl uppercase font-bold">Terry Weaver</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-7">
            <p className="tech-label mb-4"><span className="text-[#FF5A00]">●</span> Section 06 // The Story</p>
            <h2 className="font-heading text-4xl md:text-6xl uppercase font-bold tracking-tighter leading-[0.95] mb-8">
              35+ Years in Film.<br />
              <span className="chrome-text">I&apos;ve learned a thing or 3.</span>
            </h2>

            <div className="space-y-5 text-zinc-300 font-body text-lg leading-relaxed">
              <p>
                Hello, I&apos;m Terry. I&apos;ve enjoyed a crazy, stressful, creative and fulfilling career as a Prop Master in
                the Film & Television Industry for over 35 years.
              </p>
              <p>
                I&apos;ve served as a Grip, Stunt Player, Stunt Rigger and occasional actor, my primary path in
                Film has been in the Prop Department. One of the biggest challenges when creating action props are
                the paint finishes — specifically metal.
              </p>
              <p>
                I&apos;ve found and formulated what I believe to be some of the best metallic options available. My
                products have been used on hundreds of props across dozens of shows for{" "}
                <span className="text-white font-semibold">Disney, Paramount, Netflix, and Fox</span> — including{" "}
                <span className="text-[#FF5A00] font-semibold">SHŌGUN, TRACKER</span> and the upcoming{" "}
                <span className="text-[#FF5A00] font-semibold">GOD OF WAR</span>.
              </p>
              <p>
                Our most unique offering is FireKrome. You can produce true reflective chrome with the stroke of a
                brush and the sweep of a flame.
              </p>
              <p className="text-white font-semibold">FireKrome literally takes minutes.</p>
            </div>

            <div className="mt-10 flex flex-wrap gap-3">
              {["IATSE 891", "UBCP ACTRA", "PMG"].map((b) => (
                <span
                  key={b}
                  className="px-4 py-2 border border-zinc-700 font-mono text-xs uppercase tracking-widest text-zinc-300"
                  data-testid={`founder-badge-${b.replace(/\s/g, "-")}`}
                >
                  {b}
                </span>
              ))}
            </div>

            <div className="mt-10">
              <a
                href={STORE_LINKS.email}
                data-testid="founder-email-btn"
                className="btn-secondary"
              >
                ✉ Email Terry Directly
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ================== FAQ ================== */
function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 border-y border-zinc-800 bg-[#0e0e0e]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <p className="tech-label mb-4"><span className="text-[#FF5A00]">●</span> Section 07 // FAQ</p>
            <h2 className="font-heading text-4xl md:text-6xl uppercase font-bold tracking-tighter leading-[0.95]">
              FireKrome <span className="chrome-text">FAQs.</span>
            </h2>
          </div>
          <div className="md:col-span-8">
            <div className="border-t border-zinc-800">
              {FAQ.map((f, i) => (
                <details key={f.q} data-testid={`faq-item-${i}`} className="faq-row border-b border-zinc-800 group">
                  <summary className="flex items-center justify-between py-6 cursor-pointer">
                    <span className="font-heading text-xl md:text-2xl uppercase tracking-tight pr-6 group-hover:text-[#FF5A00] transition-colors">
                      {f.q}
                    </span>
                    <span className="faq-chevron text-[#FF5A00] text-2xl font-mono shrink-0">+</span>
                  </summary>
                  <p className="pb-6 text-zinc-400 font-body leading-relaxed text-lg">{f.a}</p>
                </details>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ================== CTA STRIP ================== */
function CtaStrip() {
  return (
    <section data-testid="cta-strip" className="py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 blueprint-grid opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-br from-[#FF5A00]/10 via-transparent to-transparent" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 text-center">
        <p className="tech-label mb-6">Ready to chrome it?</p>
        <h2 className="font-heading text-5xl md:text-8xl uppercase font-bold tracking-tighter leading-[0.9] mb-8">
          Get your <span className="text-[#FF5A00]">shine on</span> now!
        </h2>
        <div className="flex flex-wrap gap-4 justify-center">
          <a href={STORE_LINKS.etsy} target="_blank" rel="noopener noreferrer" data-testid="cta-etsy" className="btn-primary">
            Shop on Etsy →
          </a>
          <a href={STORE_LINKS.amazonCa} target="_blank" rel="noopener noreferrer" data-testid="cta-amazon-ca" className="btn-secondary">
            Amazon.ca
          </a>
          <a href={STORE_LINKS.amazonCom} target="_blank" rel="noopener noreferrer" data-testid="cta-amazon-com" className="btn-secondary">
            Amazon.com
          </a>
        </div>
      </div>
    </section>
  );
}

/* ================== FOOTER ================== */
function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-zinc-800 bg-[#0a0a0a] pt-16 pb-28 md:pb-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_performance-check-15/artifacts/ani5jwna_eNeo%20gold%20button.png"
                alt="eNeo logo"
                className="h-10 w-10 object-contain"
              />
              <span className="font-heading text-2xl tracking-[0.25em] uppercase font-bold text-zinc-200">
                Fire<span className="chrome-text">Krome</span>
              </span>
            </a>
            <p className="text-zinc-400 font-body max-w-md">
              Specialty reflective chrome paint finishes. Mixed in small batches in Vancouver, BC. Trusted on set by
              prop departments across North America.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="tech-label mb-4">Navigate</p>
            <ul className="space-y-2">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="font-mono text-sm text-zinc-300 hover:text-[#FF5A00]">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="tech-label mb-4">Buy / Follow</p>
            <ul className="space-y-2 font-mono text-sm">
              <li><a href={STORE_LINKS.etsy} target="_blank" rel="noopener noreferrer" className="text-zinc-300 hover:text-[#FF5A00]" data-testid="footer-etsy">→ Etsy Store</a></li>
              <li><a href={STORE_LINKS.amazonCa} target="_blank" rel="noopener noreferrer" className="text-zinc-300 hover:text-[#FF5A00]" data-testid="footer-amazon-ca">→ Amazon.ca</a></li>
              <li><a href={STORE_LINKS.amazonCom} target="_blank" rel="noopener noreferrer" className="text-zinc-300 hover:text-[#FF5A00]" data-testid="footer-amazon-com">→ Amazon.com</a></li>
              <li><a href={STORE_LINKS.youtube} target="_blank" rel="noopener noreferrer" className="text-zinc-300 hover:text-[#FF5A00]" data-testid="footer-youtube">→ YouTube</a></li>
              <li><a href={STORE_LINKS.email} className="text-zinc-300 hover:text-[#FF5A00]" data-testid="footer-email">→ eneoenterprises@gmail.com</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-zinc-800 pt-6 flex flex-wrap justify-between gap-4 font-mono text-xs uppercase tracking-widest text-zinc-500">
          <span>© {new Date().getFullYear()} Firekrome / Eneo Enterprises</span>
          <span>Vancouver, BC • Made for film, by film</span>
        </div>
      </div>
    </footer>
  );
}
